import type { ChildGender } from '../types/profile'

/** Devuelve la vocal de género: "a" para hija, "o" para hijo o sin definir. */
export function genderVowel(gender: ChildGender): 'o' | 'a' {
  return gender === 'hija' ? 'a' : 'o'
}

/** Adapta etiquetas con formato "Curioso/a" al género elegido. */
export function adaptLabel(label: string, gender: ChildGender): string {
  if (!label.includes('/a')) return label
  return gender === 'hija' ? label.replace(/o\/a/g, 'a') : label.replace(/\/a/g, '')
}

/** "hijo" o "hija" (por defecto "hijo o hija" si aún no se eligió). */
export function childWord(gender: ChildGender): string {
  if (gender === 'hija') return 'hija'
  if (gender === 'hijo') return 'hijo'
  return 'hijo o hija'
}
